import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import type { FC } from 'react';

export interface WIPChirpTicketAbortDialogPropsI {
  open: boolean;
  remainingCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation dialog shown when the user attempts to close the Create Chirp Ticket popup
 * mid-session (with 2+ records originally selected). Mirrors WarrQueue's `chirpAbortConfirmOpen`
 * behavior so the dealer doesn't accidentally throw away the remaining queued tickets.
 */
const WIPChirpTicketAbortDialog: FC<WIPChirpTicketAbortDialogPropsI> = ({
  open,
  remainingCount,
  onCancel,
  onConfirm,
}): JSX.Element => {
  let remainingText: string;
  if (remainingCount > 1) {
    remainingText = `${remainingCount} remaining tickets`;
  } else if (remainingCount === 1) {
    remainingText = '1 remaining ticket';
  } else {
    remainingText = 'remaining tickets';
  }

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="wip-chirp-abort-dialog-title"
      aria-describedby="wip-chirp-abort-dialog-description"
    >
      <DialogTitle id="wip-chirp-abort-dialog-title">Discard remaining tickets?</DialogTitle>
      <DialogContent>
        <DialogContentText id="wip-chirp-abort-dialog-description">
          {`You still have ${remainingText} queued. Closing now will discard them and you will need to reselect from the WIP list.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} autoFocus>
          Keep going
        </Button>
        <Button onClick={onConfirm} color="error">
          Discard
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WIPChirpTicketAbortDialog;
